import { vehicle } from "../en";

export const dashboard = {
  alertsStats: {
    alertsStats: "事件统计",
    avgPerVehicle: "按设备平均",
    cameraBlocked: "摄像头遮挡",
    driverName: "司机",
    DSS: "驾驶行为",
    enter: "驶入",
    exit: "驶出",
    FailedToGetAlertsStatsData: "未能获取事件统计数据，请刷新页面。",
    fatigue: "疲劳",
    front: "前方",
    geofencing: "电子围栏",
    left: "左方",
    PDCritical: "危险区违规闯入",
    PDCriticalExempted: "危险区授权作业",
    phoneUsage: "使用手机",
    rank: "排名",
    rear: "后方",
    right: "右方",
    seatbelt: "未系安全带",
    smoking: "抽烟",
    speeding: "超速",
    subtotal: "小计",
    total: "总计",
    unauthorizedDrivers: "未授权驾驶",
    vehicleID: "设备编号",
    hardHatOff: "未戴安全帽",
    frontRight: "右前方",
    rearRight: "右后方",
    cam1: "摄像头1",
    cam2: "摄像头2",
    poseAuthorization: "姿态授权申请",
  },
  drivers: "司机",
  startEndDateStr: "{0}年{1}月{2}日 | {0}年{1}月{2}日 - {3}年{4}月{5}日",
  export: {
    fleet: "@:common.vehicle.fleet",
    fleetName: "@:common.fleet.fleetName",
    confirmDateRangeForExport: "确认导出的日期范围",
    expectedUsage: "预期使用量（小时）",
    expectedUtilizationRate: "预期使用率（%）",
    export: "导出",
    fromTo: "从{0}到{1}",
    maximumUsage: "最大使用量（小时）",
    numberOfDays: "天数",
    pedestrianDetection: "@:dashboard.alertsStats.PDCritical",
    summary: "小结",
    timeRanges: "时间范围",
    totalAlerts: "警示总数",
    totalVehicles: "设备总数",
    utilizationRate: "使用率（%）",
    vehicleUsage: "设备使用量（小时）",
    alerts: "@:dashboard.rankingByVehicle.alerts",
    drivers: "@:dashboard.drivers",
    driverSafetySystem: "@:common:device.driverSafetySystem",
    inspection: "@:nav.inspection",
    inspectionTemplate: "@:nav.inspectionReports",
    vehicles: "@:dashboard.vehicles",
  },
  fleetSelect: {
    allFleets: "所有车间",
    empty: "未选择",
    totalVehicles: "总设备数",
    inlineVehicles: "在线",
  },
  inspectionStats: {
    criticalItemFailed: "有关键项未通过",
    criticalItemFailed1OrMore: "有关键项未通过",
    expected: "预期数量",
    expectedInspections: "预期点检次数",
    failedToGetInspectionStatsData: "未能获取点检统计数据，请刷新页面。",
    failedToGetMaintenanceRepairStatsData: "未能获取维保统计数据，请刷新页面。",
    failedToGetDriverExpireStatsData: "未能获取司机驾照统计数据，请刷新页面。",
    inspectionStats: "点检统计（当前周期）",
    nonCriticalItemFailed: "有非关键项未通过",
    nonCriticalItemFailed1OrMore: "有非关键项未通过",
    numberOfPassedItems: "通过的项目数量",
    numberOfSubmittedReports: "提交的点检报告数量",
    passed: "全通过",
    rank: "排名",
    reliability: "可靠性",
    reliabilityTips:
      "可靠性是指在所有提交的报告中，通过的项目数占总点检项目数的比例。",
    submission: "提交率",
    submissionTips:
      "提交率是指在当前检查周期内提交检查报告的实际设备数与设备总数之比，它是根据每个车间的检查设置确定的。",
    submitted: "提交数量",
    totalNumberOfInspectionItems: "点检项目总数",
    totalNumberOfVehiclesOperated: "工作的设备总数",
    uninspected: "{0}辆尚未点检",
    vehicleID: "设备编号",
    inspectedVehicles: "点检设备数",
    reportsSubmitted: "点检报告数",
    numberOfInspectedVehicles: "当前检查周期内提交检查报告的实际设备数",
    numberOfTotalVehicles: "设备总数",
  },
  recentMonth: "过去30天",
  recentWeek: "过去7天",
  defineDate: "自定义日期",
  noData: "@:common.global.noData",
  noFleet: {
    createNow: "现在创建",
    noFleetTips: "请先创建车间。| 还没有创建车间。",
    noVehicleTips: "请先创建设备。| 还没有创建任何设备。",
  },
  rankingByDriver: {
    alerts: "警示",
    driverName: "姓名",
    failedToGetRankingByDriverData: "未能获取司机安全驾驶数据，请刷新页面。",
    hoursDriven: "工作时长",
    rank: "排名",
    rankingByDriver: "司机安全驾驶",
    score: "风险系数",
    infoTips: "风险系数 = 警示数 / 工作时长",
  },
  rankingByVehicle: {
    alerts: "警示",
    failedToGetRankingByVehiclesData:
      "未能获取安全生产风险提示数据，请刷新页面。",
    rank: "排名",
    rankingByVehicle: "安全生产风险提示",
    hoursDriven: "运行时长（小时）",
    score: "风险系数",
    vehicleName: "设备编号",
    infoTips: "风险系数 = 警示数 / 运行时长",
  },
  refresh: "刷新",
  today: "今日",
  updateTime: "上次更新：{date}",
  vehicles: "设备",
  vehicleUsage: {
    actualUsage: "实际",
    customRange: "自定义",
    exp: "预期",
    failedToGetVehicleUsageData: "未能获取设备在线率数据，请刷新页面。",
    recentMonthsAvg: "过去30天",
    recentWeeksAvg: "过去7天",
    titleCustomRange: "自定义区间：{startDate} - {endDate}",
    titleLast30Days: "过去30天使用率",
    titleLast7Days: "过去7天使用率",
    titleTodayUsage: "今日使用率",
    todaysAvg: "今日",
    vehicleUsage: "设备在线率",
    hourSearch: "按小时",
    daySearch: "按天",
    average: "平均值",
  },
  maintenanceRepair: {
    maintenanceRepairStats: "设备维保统计",
    maintenance: "保养",
    repair: "维修",
    maintenanceApplying: "保养审批中",
    repairApplying: "维修审批中",
    inMaintenance: "保养中",
    inRepair: "维修中",
    maintenanceTitle: "设备保养情况",
    RepairTitle: "设备维修情况",
    number: "序号",
    inFleet: "所属车间",
  },
  vehicleExpireTime: {
    vehicleMaintenanceStats: "设备保养提醒",
    vehicleCheckStats: "设备年检提醒",
    vehicleMaintenanceExpire: "保养即将到期",
    vehicleCheckExpire: "年检即将到期",
    unitVehicle: "辆",
    unitPerson: "人",
    vehicleRemind: "设备提醒",
    maintenanceExpire: "保养临期",
    checkExpire: "年检临期",
    maintenanceDate: "保养日期",
    checkDate: "年检日期",
    vehicleMaintenanceExpireNumber: "({0})辆车保养超期",
    vehicleCheckExpireNumber: "({0})辆车年检超期",
  },
  driverExpireTime: {
    driverExpireTimeStats: "司机驾照提醒",
    driverCertExpire: "驾照即将到期",
    driverRemind: "司机驾照到期提醒",
    certExpireDate: "驾照到期日",
    driverCertExpireNumber: "({0})位司机驾照超期",
  },
  healthReport: {
    healthReportStats: "AI主机异常次数统计（今日）",
    seatBeltLowBattery: "安全带传感器低电量",
    speedSensorLowBattery: "速度传感器低电量",
    SDCardError: "SD卡异常",
    extendSDCardError: "扩展SD卡异常",
    cameraError: "摄像头异常",
    total: "总计",
    failedToGetHealthReportStatsData:
      "未能获取AI主机异常统计数据，请刷新页面。",
    number: "序号",
    lastReportTime: "最近上报时间",
    vehicleNo: "设备编号",
  },
  vehicleGPSInfo: "设备实时定位信息",
};
